import React from 'react';
import {Col, Container, Row } from 'reactstrap';
import { T } from '../traks';


function Partners(props) {
	return (
		<Container>
			<Row className="ad_game_card bg-white pt-4 ad_pb-10">
				<Col xs="12">
				</Col>
				<Col className="py-5" xs="12">
					<h2><T>Our partners</T></h2>
					<T>
					Have a look at our awesome partners here. Great companies we really enjoy working with.
					</T>
				</Col>
				<Col className="pt-5" xs="12" lg="4">
					<a target="_blank" rel="noopener noreferrer" href="https://iextrading.com/">
						<img alt="IEX Group" src="/gfx/IEX-Group-logo-208x121-0.jpg"
						srcSet="/gfx/IEX-Group-logo-208x121-0.jpg 1x, /gfx/IEX-Group-logo-416x241-0.jpg 2x"/>
					</a>
				</Col>
				<Col className="pt-5" xs="12" lg="8">
					<div className="ad_150pct pt-lg-5"><b><T>
						IEX Group
					</T></b></div>
					<div><T>
						IEX Group operates the Investors Exchange (IEX), a stock exchange for U.S. equities
						that is built for investors and companies.
					</T></div>
				</Col>
			</Row>
		</Container>
	);
}

export default Partners;



// WEBPACK FOOTER //
// ./src/p/Partners.js